<template>
  <div>
    <div class="cus-panel-heading">
      <h4 class="cus-panel-title">My Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :checkAlert="checkAlert"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :hideSelectingColumn="true"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <!-- <div class="d-flex" style="flex-wrap: wrap"> -->
          <v-layout
            row
            wrap
          >
            <v-flex
              v-for="(status, index) in statusesList"
              :key="status.value"
              xs6
              sm3
              md3
              lg2
              xl1
              class="mb-3 text-center"
            >
              <div
                class="label pointer not-selectable custom-label"
                :class="getBgColor(index)"
                :style="tableData.status_id === status.value ? 'border: 2px solid #000;' : ''"
                @click="filterByStatus(status.value)"
              >
                {{ status.text }}
              </div>
            </v-flex>
          </v-layout>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td style="white-space: nowrap;">{{ r.theOrderID }}</td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name : '' }}</td>
                <td>
                  <span
                    v-if="r.order_status === 'new_order'"
                    class="label bg-primary-600"
                  > {{ r.order_status.replace('_', ' ') }}</span>

                  <span
                    v-if="r.order_status === 'processed_order'"
                    class="label bg-indigo-600"
                  > {{ r.order_status.replace('_', ' ') }}</span>

                  <span
                    v-if="r.order_status === 'canceled'"
                    class="label bg-orange-600"
                  > {{ r.order_status }}</span>

                  <span
                    v-if="r.order_status === 'refunded'"
                    class="label bg-danger-600"
                  > {{ r.order_status }}</span>

                  <span
                    v-if="r.order_status === 'approved_order'"
                    class="label bg-green-600"
                  >
                    {{ r.order_status.replace('_', ' ') }}
                  </span>

                  <span
                    v-if="r.order_status === 'pending_answer'"
                    class="label bg-grey-600"
                  >
                    {{ r.order_status.replace('_', ' ') }}
                  </span>

                  <span
                    v-if="r.order_status === 'purchased'"
                    class="label bg-teal-400"
                  > {{ r.order_status }}</span>

                  <span
                    v-if="r.order_status === 'warehouse_delivered_order'"
                    class="label bg-purple-400"
                  >
                    {{ r.order_status.replace('_', ' ').replace('_order', '') }}</span>
                  <span
                    v-if="r.order_status === 'pending_to_shipment'"
                    class="label bg-purple-400"
                  >
                    Warehouse Delivered</span>

                  <span
                    v-if="r.order_status === 'int_shipment' || r.order_status === 'pending_to_branch'"
                    class="label bg-info-400"
                  >
                    int shipment
                    <!-- {{ r.order_status.replace('_', ' ') }} -->
                  </span>
                  <!-- <td>
                  <span v-if="r.order_status === 'pending_to_branch'" class="label bg-pink-400"> {{ r.order_status.replaceAll('_', ' ') }}</span>
                </td> -->
                  <span
                    v-if="r.order_status === 'branch_delivery'"
                    class="label bg-violet-600"
                  > {{ r.order_status.replace('_', ' ') }}</span>

                  <span
                    v-if="r.order_status === 'delivered'"
                    class="label bg-warning-300"
                  > {{ r.order_status }}</span>

                  <span
                    v-if="r.order_status === 'ship_only'"
                    class="label bg-blue-300"
                  >
                    {{ r.order_status.replace('_', ' ') }}
                    <span style="display: block">{{ r.track_number }}</span>
                  </span>
                </td>
                <td>
                  <div v-if="r.total_amount">${{ r.total_amount }}</div>
                </td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <router-link
                  v-if="r.order_status !== 'ship_only'"
                  :to="'/order-detail?id=' + r.order_id"
                  tag="td"
                  style="padding-left:0px; padding-right:5px"
                ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                <router-link
                  v-if="r.status_id_fk == 1"
                  :to="`/make-new-order?order_id=${r.order_id}`"
                  tag="td"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a tooltip="Edit Order"><i
                      class="fa fa-edit"
                      style="font-size: 22px"
                    /></a>
                </router-link>
                <td
                  v-if="r.order_status === 'ship_only' && !r.track_number"
                  style="padding-left:5px; padding-right:5px"
                >
                  <a
                    @click="openAddTrackNumberDialog(r)"
                    style="color:#44aa44"
                    tooltip="Add track number"
                  ><i class="material-icons">add_box</i></a>
                </td>
                <td
                  v-if="r.order_status === 'new_order' || r.order_status === 'processed_order'"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    @click="openCancelingOrderModal(r.order_id)"
                    style="color:#C62828"
                    tooltip="Cancel This Order"
                  ><i class="material-icons">cancel</i></a>
                </td>
                <td
                  v-if="r.order_status === 'processed_order'"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    @click="approvingOrder(r.order_id)"
                    style="color:#43A047"
                    tooltip="Approve This Order"
                  ><i class="material-icons">check_circle</i></a>
                </td>
                <td
                  v-if="r.status_id_fk > 3 && r.status_id_fk < 12"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showAppLog', r.order_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
                <td
                  v-if="['approved_order', 'purchased', 'warehouse_delivered_order'].includes(r.order_status)"
                  class="px-2"
                >
                  <a
                    @click="openCreateOrderCaseModal(r)"
                    style="color: #555"
                    tooltip="Create Case"
                  >
                    <i
                      class="fa fa-folder-open"
                      style="font-size: 1.6rem"
                    />
                  </a>
                </td>
                <td
                  v-if="
                    r.order_status === 'delivered' ||
                      r.order_status === 'canceled' ||
                      r.order_status === 'refunded'
                  "
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    @click="archiveOrder(r.order_id)"
                    style="color:#424242"
                    tooltip="Archive This Order"
                  ><i class="material-icons">archive</i></a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <!-- %%%%%%%%% Mobile Table %%%%%%%%%% -->

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.theOrderID }}, <br />
                  {{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  Quantity : {{ r.quantity }}
                </td>
                <td v-if="r.order_status === 'new_order'">
                  <span class="label bg-primary-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span style="padding-left:0px; padding-right:3px">
                    <a
                      @click="openCancelingOrderModal(r.order_id)"
                      style="color:#C62828"
                      tooltip="Cancel This Order"
                    ><i class="material-icons">cancel</i></a>
                  </span>
                </td>

                <td v-if="r.order_status === 'processed_order'">
                  <span class="label bg-indigo-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span style="padding-left:0px; padding-right:3px">
                    <a
                      @click="openCancelingOrderModal(r.order_id)"
                      style="color:#C62828"
                      tooltip="Cancel This Order"
                    ><i class="material-icons">cancel</i></a>
                  </span>
                  <span
                    v-if="r.order_status === 'processed_order'"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      @click="approvingOrder(r.order_id)"
                      style="color:#43A047"
                      tooltip="Approve This Order"
                    ><i class="material-icons">check_circle</i></a>
                  </span>
                </td>

                <td v-if="r.order_status === 'canceled'">
                  <span class="label bg-orange-600"> {{ r.order_status }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                </td>

                <td v-if="r.order_status === 'refunded'">
                  <span class="label bg-danger-600"> {{ r.order_status }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>

                <td v-if="r.order_status === 'approved_order'">
                  <span class="label bg-green-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>

                <td v-if="r.order_status === 'purchased'">
                  <span class="label bg-teal-400"> {{ r.order_status }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span><br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>

                <td v-if="r.order_status === 'warehouse_delivered_order'">
                  <span class="label bg-purple-400">
                    {{ r.order_status.replace('_', ' ').replace('_order', '') }}
                  </span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>

                <td v-if="r.order_status === 'int_shipment'">
                  <span class="label bg-info-400"> {{ r.order_status.replace('_', ' ') }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>

                <td v-if="r.order_status === 'branch_delivery'">
                  <span class="label bg-violet-600"> {{ r.order_status.replace('_', ' ') }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>

                <td v-if="r.order_status === 'delivered'">
                  <span class="label bg-warning-300"> {{ r.order_status }}</span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span
                    v-if="r.status_id_fk > 3"
                    style="padding-left:0px; padding-right:3px"
                  >
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showAppLog', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                  <span
                    v-if="r.order_status === 'delivered'"
                    style="padding-left:0px; padding-right:5px"
                  >
                    <a
                      @click="archiveOrder(r.order_id)"
                      style="color:#424242"
                      tooltip="Archive This Order"
                    ><i class="material-icons">archive</i></a>
                  </span>
                </td>

                <td v-if="r.order_status === 'ship_only'">
                  <span class="label bg-blue-300">
                    {{ r.order_status.replace('_', ' ') }}
                    <span style="display: block">{{ r.track_number }}</span>
                  </span>
                  <br />
                  <span
                    v-if="r.total_amount"
                    class="mt-1 d-inline-block"
                  >${{ r.total_amount }}</span>
                  <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else> {{ r.created_at }}</span>
                  <br />

                  <span
                    v-if="r.order_status === 'ship_only' && !r.track_number"
                    style="padding-left:5px; padding-right:5px"
                  >
                    <a
                      @click="openAddTrackNumberDialog(r)"
                      style="color:#44aa44"
                      tooltip="Add track number"
                    ><i class="material-icons">add_box</i></a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-log-details
            :detialData="detialData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-log-details>

          <customer-cancel-order
            :closeCancelingOrderModal="closeCancelingOrderModal"
            :cancelOrderModal="cancelOrderModal"
            :cancelAlert="cancelAlert"
            :cancelData="cancelData"
            :cancelingOrder="cancelingOrder"
          ></customer-cancel-order>

          <add-track-number
            :orderId="orderId"
            :trackNumDialog="trackNumDialog"
            @close="trackNumDialog = false"
            @resetTable="getResults()"
          />

          <add-address
            :addressDialog="
              !loggedInUserData.governorate_id_fk ||
              !loggedInUserData.city_id_fk ||
              !loggedInUserData.address ||
              loggedInUserData.address.length < 3
            "
            :customer="loggedInUserData"
            :governoratesList="governoratesList"
            :citiesList="citiesList"
            @resetTable="getResults()"
            @refetchUser="getUser"
          />

          <approve-order
            :orderId="orderId"
            :approveDialog="approveDialog"
            @close="approveDialog = false"
            @resetTable="getResults()"
          />

          <add-edit-order-case
            :addEditOrderCaseModal="addEditOrderCaseModal"
            :formData="formData"
            fromCustomer
            @close="addEditOrderCaseModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewLogDetails from '../logs/viewLogDetails.vue'
import mobileDatatable from '../mobileDatatable'
import customerCancelOrder from './customerCancelOrder'
import approveOrder from './approveOrder.vue'
import addTrackNumber from './addTrackNumber'
import addAddress from './addAddress.vue'
import addEditOrderCase from '../orderCase/addEditOrderCase.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-log-details': viewLogDetails,
    'mobile-datatable': mobileDatatable,
    'customer-cancel-order': customerCancelOrder,
    addTrackNumber,
    addAddress,
    approveOrder,
    addEditOrderCase
  },
  created() {
    this.getLoggedInUser()
  },
  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
    this.perPageFix(50)
    this.getStatusesList()
    this.getGovernorateList()
    this.getCityList()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', sortable: true, searchable: true, name: 'theOrderID' },
      { label: 'Product URL', sortable: true, searchable: true, name: 'product_url' },
      { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' },
      { label: 'Quantity', sortable: true, searchable: true, name: 'quantity' },
      { label: 'Warehouse', sortable: true, searchable: true, name: 'country' },
      { label: 'Transportation Type', sortable: false, searchable: false, name: 'transportation_type_obj' },
      { label: 'Orders Status', sortable: true, searchable: true, name: 'order_status' },
      { label: 'Total Price', sortable: true, searchable: true, name: 'total_amount' },
      { label: 'Order note', sortable: true, searchable: true, name: 'note' },
      { label: 'Date', sortable: true, searchable: true, name: 'created_at' }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      trackNumDialog: false,
      orderId: 0,
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      approveDialog: false,
      url: 'api/orders',
      logDetailUrl: 'api/order_credit_log_transaction',
      cancelingOrderUrl: 'api/canceling_order',
      archivingOrderUrl: 'api/archiving_order',
      companyUrl: 'api/company_info',
      dependDate: 'orders.created_at',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      formData: {},
      addEditOrderCaseModal: false,
      loggedInUserData: {},
      statusesList: [],
      governoratesList: [],
      citiesList: [],
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      detialData: {
        credit_log_transaction_date: '',
        credit_log_transaction_id: '',
        invoice_number: '',
        amount: '',
        created_at: '',
        full_name: '',
        email: '',
        address: '',
        quantity_charge: '',
        phone_number: '',
        product_name: '',
        quantity: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        description: ''
      },
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      cancelData: {
        cancel_reason: ''
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      tableData: {
        per_page: 50,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getGovernorateList() {
      let token = localStorage.getItem('access_token')

      axios.get('api/governorate/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.governoratesList = response.data
      })
    },

    getCityList() {
      let token = localStorage.getItem('access_token')

      axios.get('api/city/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then((response) => {
        this.citiesList = response.data
      })
    },

    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'
      let perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page
      let page = this.pagination.currentPage || 1
      let statusId = this.tableData.status_id || '0'
      if (
        searchValue !== '0' ||
        searchedOneCol !== '0' ||
        searchedOneVal !== '0' ||
        toDate !== '0' ||
        fromDate !== '0'
      ) {
        perPage = '0'
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      window.location.replace(
        fullHostName +
        '/api/my-order-export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&depend_date=' +
        this.dependDate +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate +
        '&per_page=' +
        perPage +
        '&page=' +
        page +
        '&status=' +
        statusId +
        '&access_token=' +
        localStorage.getItem('access_token')
      )
    },

    openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      }
      this.addEditOrderCaseModal = true
    },

    filterByStatus(statusId) {
      this.tableData.status_id = statusId
      this.getResults()
    },

    getBgColor(index) {
      if (index === 0) return 'bg-grey-600'
      if (index === 1) return 'bg-primary-600'
      if (index === 2) return 'bg-indigo-600'
      if (index === 3) return 'bg-orange-600'
      if (index === 4) return 'bg-green-600'
      if (index === 5) return 'bg-danger-600'
      if (index === 6) return 'bg-teal-400'
      if (index === 7) return 'bg-purple-400'
      if (index === 8) return 'bg-info-400'
      if (index === 9) return 'bg-violet-600'
      if (index === 10) return 'bg-warning-300'
      if (index === 11) return 'bg-blue-300'
      if (index === 12) return 'bg-pink-400'
      if (index === 13) return 'bg-warning-400'
    },

    getStatusesList() {
      this.statusesList = [{ text: 'all', value: null }]
      let token = localStorage.getItem('access_token')
      axios.get('api/status/list', { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        res.data.forEach(item => {
          if (item.status_id !== 13)
          {
            this.statusesList.push({ text: item.type.replaceAll('_', ' ').replaceAll('order', ''), value: item.status_id })
            if(item.status_id === 8) {
              this.statusesList.push({ text: 'Delivered to Erbil', value: item.status_id })
            }
          }
        })
      })
    },

    openAddTrackNumberDialog(row) {
      this.orderId = row.order_id
      this.trackNumDialog = true
    },

    openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true
      this.theCancelOrderID = orderId
    },

    closeCancelingOrderModal() {
      this.cancelOrderModal = false
      this.cancelAlert = false
      this.cancelData.cancel_reason = ''
    },

    cancelingOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.getResults()
          this.cancelAlert = true
          let self = this
          setTimeout(() => {
            self.closeCancelingOrderModal()
          }, 1500)
        })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then((response) => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
        this.loggedInUserData = response.data
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          this.apiResults = data.data.data

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          this.configPagination(data.data)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .catch((errors) => { })
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    approvingOrder(id) {
      this.orderId = id
      this.approveDialog = true
    },

    archiveOrder(id) {
      swal({
        title: 'Are you sure?',
        text: 'Once archived, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then((approved) => {
        if (approved) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.archivingOrderUrl + '/' + id, '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then((response) => {
              this.getResults()
              swal({
                title: 'Done',
                text: 'Archived',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch((error) => {
              if (error.response) {
                swal('Error', `${error.response.message}`, 'error')
              }
            })
        }
      })
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

.pointer {
  cursor: pointer;
}

.not-selectable {
  user-select: none;
}

.custom-label {
  font-size: 11px;
  border-radius: 4px;
  padding: 2px 10px;
  width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/myOrders.vue